import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteLiveStreamResponseBody } from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';
import { liveStreamQueryKeyFactory } from './useLiveStreamQuery';
import { liveStreamsQueryKeyFactory } from './useLiveStreamsQuery';

export type IUseDeleteLiveStreamMutationValues = {
  appId: string;
  liveStreamId: string;
};

export const useDeleteLiveStreamMutation = (): UseMutationResult<
  IApiDeleteLiveStreamResponseBody,
  unknown,
  IUseDeleteLiveStreamMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteLiveStreamMutationValues) =>
      api.liveStreams.delete(values.appId, values.liveStreamId),
    onSuccess: async (_, values) => {
      [
        // TODO once the API is updated to return the deleted resources
        // data.deletedResources.streamIds
        values.liveStreamId,
      ]
        .map((streamId) => [
          {
            queryKey: liveStreamQueryKeyFactory({
              appId: values.appId,
              liveStreamId: streamId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: liveStreamsQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
